import { Dialog, Divider, Grid } from "@material-ui/core";
import * as React from "react";
import { Create, Datagrid, List, required, SimpleForm, TextField, TextInput, useNotify } from "react-admin";
import { SectionTitle } from "../../../../../src/Components/SectionTitle";
import { CustomDateField } from "../../../../Components/CustomDateField";
import CreatedByField from "../../../../../src/Components/ReferenceFields/CreatedBy/CreatedByField";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../../../../src/Constants/Constant";
import UpdatedByField from "../../../../../src/Components/ReferenceFields/UpdatedBy/UpdatedByField";
import { ReserveActions } from "./ReserveActions";

export default function RequestOrderReserveForm(props) {
  const [open, setOpen] = React.useState(false);
  const notify = useNotify();

  React.useEffect(() => {
    setOpen(props?.open ?? false);
  }, [props.open]);

  const handleClose = () => {
    setOpen(false);
    props?.handleClose(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose} maxWidth={"lg"}>
        <Grid container style={{ padding: 20 }}>
          <Grid item xs={12}>
            <Create
              basePath="list"
              title={" "}
              resource={"requestreserves"}
              onFailure={result => {
                notify(`${result?.response?.data}`, "error", false, true);
              }}
            >
              <SimpleForm>
                <Grid style={{ width: "100%" }} container spacing={2}>
                  <Grid
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                    item
                    xs={12}
                  >
                    <Divider />
                    <Divider />
                    <SectionTitle variant={"h5"} label={"Create Form"} />
                  </Grid>

                  <Grid item xs={6} sm={3} lg={3}>
                    <TextInput
                      source="requestId"
                      label="Request"
                      fullWidth
                      disabled
                      defaultValue={props.requestId}
                      validate={required()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={6} sm={3} lg={3}>
                    <TextInput
                      source="refNo"
                      label="Request Ref No"
                      fullWidth
                      disabled
                      defaultValue={props.refNo}
                      validate={required()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={6} sm={3} lg={3}>
                    <TextInput source="pn" label="Pn" fullWidth validate={required()} variant="outlined" />
                  </Grid>
                  <Grid item xs={6} sm={3} lg={3}>
                    <TextInput source="sn" label="Sn" fullWidth validate={required()} variant="outlined" />
                  </Grid>
                </Grid>
              </SimpleForm>
            </Create>
          </Grid>

          <Grid style={{ display: "flex", justifyContent: "center", marginTop: 30 }} item xs={12}>
            <Divider />
            <Divider />
            <SectionTitle variant={"h5"} label={"Reserved History (Ref No =" + props?.refNo + ")"} />
          </Grid>
          <Grid item xs={12}>
            <List
              {...props}
              title={" "}
              resource={"requestreserves"}
              basePath={"list"}
              filterDefaultValues={{ requestId__eq: props.requestId }}
              sort={DefaultCreatedDateSort}
              perPage={DefaultPerPageSize}
              actions={false}
              bulkActionButtons={false}
              exporter={false}
              hasCreate={false}
            >
              <Datagrid
                title={""}
                optimized
                rowStyle={(record, index) => ({
                  backgroundColor: record.isPassive === true ? "#3f3e3e2e" : "white",
                })}
              >
                <ReserveActions label="Actions" />
                <TextField source="pn" label="Pn" />
                <TextField source="sn" label="Sn" />
                <CreatedByField label="Reserved By" link={false} />
                <CustomDateField source="createdDate" label="Reserved Date" showTime />
                <UpdatedByField label="Passivated By" link={false} />
                <CustomDateField source="updatedDate" label="Passivated Date" showTime />
              </Datagrid>
            </List>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
}
